import React, { useEffect, useState } from "react";
import { MainWrapper } from "../component/MainWrapper";
import { Sidebar } from "./component/Sidebar";
import { Account } from "./component/Account";
import { Notification } from "./component/Notifications";
import { Balance } from "./component/Balance";
import { Transaction } from "./component/Transaction";
import { FormattedMessage } from "react-intl";
import { Payment } from "./component/Payment";
import { useParams, useSearchParams } from "react-router-dom";
import { KYCSettings } from "./component/KYCSettings";
import { IndividualSettingData } from "../component/SidebarItems";
import RegionInfoSettings from "app/pages/component/RegionInfoSettings";
export const AccountSetting = () => {
  const [Tab, setTab] = useState("Account Settings");
  const [title, setTitle] = useState(
    <FormattedMessage
      id="INDIVIDUAL.SETTINGS.MENU.ACCOUNT.TITLE"
      defaultMessage="Account Settings"
    />,
  );
  const HandleTab = (data) => {
    setTab(data.props.defaultMessage);
    setTitle(data);
  };
  const param = useParams();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const { tab } = param;
    if (tab === "payment") {
      setTab("Payment Setting");
    }
    if (searchParams.get("tab")) {
      console.log(searchParams.get("tab"));
      let selectedtab = IndividualSettingData.find(
        (f) => f.tag && f.tag == searchParams.get("tab"),
      );
      if (selectedtab && Object.keys(selectedtab) && selectedtab.text) {
        HandleTab(selectedtab.text);
      }
    }
  }, [param]);
  return (
    <MainWrapper>
      <div className="py-2 flex space-x-2">
        <Sidebar activeTab={Tab} HandleTabs={HandleTab} />
        <div className="flex-1 bg-white p-10 rounded-lg">
          <h1 className=" text-xl mb-3 pb-3 border-b border-neutral-200">
            {title}
          </h1>
          {Tab === "Account Settings" && <Account />}
          {Tab === "Notification" && <Notification />}
          {Tab === "Account Balance" && <Balance />}
          {Tab === "Payment Setting" && <Payment />}
          {Tab === "Transaction History" && <Transaction />}
          {/* {Tab === "KYC Settings" && <KYCSettings />} */}
          {Tab === "Regions" && <RegionInfoSettings />}
        </div>
      </div>
    </MainWrapper>
  );
};
